/**
 * Utility functions for managing credit package selections
 * Persists selections to localStorage to preserve state when navigating between pages
 */

const STORAGE_KEY = 'credit-package-selections';

/**
 * Save package selections to localStorage
 */
export function savePackageSelections(selections: Map<string, number>): void {
    try {
        const selectionsArray = Array.from(selections.entries());
        localStorage.setItem(STORAGE_KEY, JSON.stringify(selectionsArray));
    } catch (error) {
        console.error('Failed to save package selections:', error);
    }
}

/**
 * Load package selections from localStorage
 */
export function loadPackageSelections(): Map<string, number> {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored) {
            const selectionsArray = JSON.parse(stored) as [string, number][];
            return new Map(selectionsArray);
        }
    } catch (error) {
        console.error('Failed to load package selections:', error);
    }
    return new Map();
}

/**
 * Clear package selections from localStorage
 */
export function clearPackageSelections(): void {
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
        console.error('Failed to clear package selections:', error);
    }
}

